// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"57":"51f2ee7d00cc0aa4","182":"e066897fe4867a39","604":"80c2123e61e295e1"}[chunkId] + ".css";
};